import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Theme, ThemeColor, ThemeColorLabel } from 'src/app/types/theme';
import { CONSTANTS } from 'src/app/providers/constants';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEMES: Record<ThemeColor, Theme> = {
    sunsetEmber: {
      id: ThemeColor.sunsetEmber,
      name: ThemeColorLabel.sunsetEmber,
      type: 'primary',
      image: 'assets/image/appearances/sunset-ember.png',
      isDefault: true,
    },
    classicNoir: {
      id: ThemeColor.classicNoir,
      name: ThemeColorLabel.classicNoir,
      type: 'secondary',
      image: 'assets/image/appearances/classic-noir.png',
      isDefault: false,
    },
  };
  constants = inject(CONSTANTS);

  private _theme$ = new BehaviorSubject<Theme>(this.THEMES[ThemeColor.sunsetEmber]);

  get currentTheme$() {
    return this._theme$.asObservable();
  }

  get themes(): Theme[] {
    return Object.values(this.THEMES);
  }

  loadSavedTheme(): Theme | null {
    const savedThemeId = localStorage.getItem(this.constants.SELECTED_THEME_KEY as string) as ThemeColor | null;
    return savedThemeId ? this.THEMES[savedThemeId] : this.THEMES[ThemeColor.sunsetEmber];
  }

  setTheme(themeId: ThemeColor): void {
    const theme = this.THEMES[themeId];
    if (!theme) return;

    // Save to localStorage
    localStorage.setItem(this.constants.SELECTED_THEME_KEY as string, themeId);

    // Apply theme immediately
    this.applyTheme(theme);
  }

  private applyTheme(theme: Theme) {
    this._theme$.next(theme);
    document.documentElement.setAttribute('data-theme', theme.id);
  }
}
